export default class CardSliderHtml {
    constructor(headline, subline, items, colSize) {
        this._headline = headline;
        this._subline = subline;
        this._items = items;
        this._colSize = colSize;

        switch (colSize) {
            case 4: this._slidesToShow = 3; break;
            default: this._slidesToShow = 3; break;
        }
    }

    _getItemHtml() {
        let itemsHtml = '';

        this._items.forEach((item) => {
            // console.log('card-slider-html _getItemHtml() item: ');
            // console.log(item);
            itemsHtml += `
                <div class="rfct-card-slider__slide swiper-slide col-xs-${this._colSize}">
                    ${item}
                </div>
            `;
        });

        return itemsHtml;
    }

    _getHeadlineHtml() {
        return this._headline ? `<h2 class="rfct-card-slider__headline">${this._headline}</h2>` : '';
    }

    _getSublineHtml() {
        return this._subline ? `<h3 class="rfct-card-slider__subline">${this._subline}</h3>` : '';
    }

    toString() {
        return `
            <div class="rfct-card-slider" data-slides-lg="${this._slidesToShow}">
                ${this._getHeadlineHtml()}
                ${this._getSublineHtml()}
                <div class="rfct-card-slider__slider">
                    <div class="rfct-card-slider__slide-container swiper row">
                        <div class="swiper-wrapper">
                        ${this._getItemHtml()}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
